import { get } from 'svelte/store';
import { authToken } from '@dopry/svelte-auth0';
import { CustomerFeedbackContext } from '../model/CustomerFeedback';
const apiUrl = "process.env.API_URL";
const previewUrl = "process.env.PREVIEW_URL";
export async function loadWorkflowExecutions(token) {
    if (token !== '') {
        return (await fetch(apiUrl + 'workflow/execution?status=COMPLETED', {
            headers: new Headers({
                Authorization: `Bearer ${token}`,
            }),
        })).json();
    }
}
export async function loadImage(inputHash, resultHash) {
    const inputData = await fetch(previewUrl + `preview_zoom/${inputHash}`, {
        headers: new Headers({
            Authorization: `Bearer ${get(authToken)}`,
        }),
    });
    const resultData = await fetch(previewUrl + `preview_zoom/${resultHash}`, {
        headers: new Headers({
            Authorization: `Bearer ${get(authToken)}`,
        }),
    });
    return [await inputData.blob(), await resultData.blob()];
}
export async function vote(token, id, rating) {
    const customerFeedback = {
        rating,
        context: CustomerFeedbackContext.TEST,
        executionId: id,
        images: [],
        message: '',
    };
    return await fetch(apiUrl + 'customer-feedback', {
        method: 'POST',
        headers: new Headers({
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(customerFeedback),
    });
}
